import React from 'react';
import dayjs from 'dayjs';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import { t } from 'i18next';

export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const years = () => {
  const minYear = 1900;
  const maxYear = 2100;

  const options = [];
  for (let i = minYear; i <= maxYear; i += 1) {
    options.push(i);
  }
  return options;
};

const Header = ({
  date,
  changeYear,
  changeMonth,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}) => {
  const selected = date ? dayjs(date) : dayjs();
  return (
    <div className={styles.customHeader}>
      <select
        value={months[selected.month()]}
        // className={classes.selectColors}
        style={{
          width: months[selected.month()].length * 25,
        }}
        onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}
      >
        {months.map(option => (
          <option key={option} value={option}>
            {t(option)}
          </option>
        ))}
      </select>
      <select
        value={selected.year()}
        onChange={({ target: { value } }) => changeYear(value)}
      >
        {years().map(option => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>

      <div className={styles.navigation}>
        <IconButton
          disableRipple
          aria-label="previous-month"
          onClick={decreaseMonth}
          disabled={prevMonthButtonDisabled}
          className={styles.previousMonth}
        >
          <KeyboardArrowUpIcon className={styles.icon} />
        </IconButton>
        <IconButton
          disableRipple
          aria-label="next-month"
          onClick={increaseMonth}
          className={styles.nextMonth}
          disabled={nextMonthButtonDisabled}
        >
          <KeyboardArrowDownIcon className={styles.icon} />
        </IconButton>
      </div>
    </div>
  );
};

Header.propTypes = {
  date: PropTypes.string,
  changeYear: PropTypes.func,
  changeMonth: PropTypes.func,
  decreaseMonth: PropTypes.string,
  increaseMonth: PropTypes.string,
  prevMonthButtonDisabled: PropTypes.bool,
  nextMonthButtonDisabled: PropTypes.bool,
};

export default Header;
